import axios from 'axios';

const ClaimForm = {
	email(data) {
		return axios({
			method: 'POST',
			url: process.env.VUE_APP_API_URI7 + '/email-claim-form',
			data,
		});
	},
};
export default ClaimForm;
